import { SportsStatIdConfig } from '@collector/desktop-feature-statistics'
import { VolleyballStatId } from '@collector/sportsapi-client-legacy'

export const teamStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: VolleyballStatId.PointsScored },
  { sportStatId: VolleyballStatId.ServiceAttempts },
  { sportStatId: VolleyballStatId.ServiceErrors },
  { sportStatId: VolleyballStatId.Aces, name: 'Service aces' },
  { sportStatId: VolleyballStatId.AttackAttempts },
  { sportStatId: VolleyballStatId.AttackErrors },
  { sportStatId: VolleyballStatId.AttackPoints },
  { sportStatId: VolleyballStatId.AttacksBlocked, name: 'Attacks blocked' },
  { sportStatId: VolleyballStatId.BlockPoints },
  { sportStatId: VolleyballStatId.TeamErrors },
  { sportStatId: VolleyballStatId.OpponentErrors },
]

export const teamStatsAccordionIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: VolleyballStatId.Challenges },
  { sportStatId: VolleyballStatId.ChallengesCorrect },
  { sportStatId: VolleyballStatId.ChallengesIncorrect },
  { sportStatId: VolleyballStatId.YellowCards },
  { sportStatId: VolleyballStatId.RedCards },
  { sportStatId: VolleyballStatId.NeutralAttacks },
  { sportStatId: VolleyballStatId.Sets },
  { sportStatId: VolleyballStatId.Digs },
  {
    sportStatId: VolleyballStatId.AttackEfficiency,
    format: { percent: true },
    edit: { disabled: true },
  },
  {
    sportStatId: VolleyballStatId.PositiveReceptionEfficiency,
    format: { percent: true },
    edit: { disabled: true },
  },
  {
    sportStatId: VolleyballStatId.PerfectReceptionEfficiency,
    format: { percent: true },
    edit: { disabled: true },
  },
  {
    sportStatId: VolleyballStatId.ServiceEfficiency,
    format: { percent: true },
    edit: { disabled: true },
  },
]

export const playerStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: VolleyballStatId.Appearance },
  { sportStatId: VolleyballStatId.FirstAppearance, name: '1S' },
  { sportStatId: VolleyballStatId.SecondAppearance, name: '2S' },
  { sportStatId: VolleyballStatId.ThirdAppearance, name: '3S' },
  { sportStatId: VolleyballStatId.FourthAppearance, name: '4S' },
  { sportStatId: VolleyballStatId.FifthAppearance, name: '5S' },
  { sportStatId: VolleyballStatId.GoldenSetAppearance, name: 'GS' },
  { sportStatId: VolleyballStatId.PointsScored },
  { sportStatId: VolleyballStatId.PointsRatio },
  { sportStatId: VolleyballStatId.ServiceAttempts },
  { sportStatId: VolleyballStatId.ServiceErrors },
  { sportStatId: VolleyballStatId.Aces, name: 'Service aces' },
  { sportStatId: VolleyballStatId.AttackAttempts },
  { sportStatId: VolleyballStatId.AttackErrors },
  { sportStatId: VolleyballStatId.AttacksBlocked, name: 'Attacks blocked' },
  { sportStatId: VolleyballStatId.AttackPoints },
  { sportStatId: VolleyballStatId.BlockPoints },
  { sportStatId: VolleyballStatId.Sets },
  { sportStatId: VolleyballStatId.Digs },
]
